<template>
    <div class="mb25" v-show="isShow">
        <div v-if="firms.length > 1">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :on-cancel="onCancel"
                     :is-full-page="fullPage">
            </loading>
            <label class="order__input-label" for="UserForm_firm_id">Ваши организации</label>
            <div class="order__input-wr">
                <select v-model="firmDefaultId" class="order__input" name="UserForm[firm_id]" id="UserForm_firm_id">
                    <option v-for="firm in firms" :value="firm.id">{{ firm.name}}</option>
                </select>

            </div>
        </div>

        <button type="button" class="mt-2 btn btn--red btn--small" @click.prevent="addFirm()">Добавить новую организацию</button>

    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "select-firm",
        components: {
            Loading
        },
        data () {
            return {
                isLoading: false, // loading-overlay param
                fullPage: true, // loading-overlay param
            };
        },
        computed: {
            isShow() {
                return this.$store.getters.pay_type === '3';
            },
            firms() {
                return this.$store.getters.firms;
            },
            firmDefaultId: {
                get: function () {
                    return this.$store.getters.firmDefaultId;
                },
                set: function (value) {
                    this.isLoading = true;
                    this.$store.dispatch("setDefaultFirm", value).then(response => {
                        this.isLoading = false;
                    })
                }
            },
        },
        methods: {
            getFirms () {
                this.$store.dispatch("getFirms");

            },
            onCancel() {
                console.log('User cancelled the loader.')
            },
            addFirm() {
                this.isLoading = true;
                this.$store.dispatch("addFirm").then(() => {
                    this.isLoading = false;
                })
            }
        },
        mounted () {
            this.getFirms();
        }
    }
</script>
